module.exports = __webpack_public_path__ + "img/alarm-exclamation.2ed63e1e.svg";